import React from 'react';
import './Education.css';
import { FaGraduationCap } from 'react-icons/fa';

function Education() {
  const educationItems = [
    {
      degree: 'Diploma of Information Technology',
      institution: 'TAFE Queensland',
      year: '2013'
    }
  ];

  return (
    <div className="education">
      <h2><FaGraduationCap className="section-icon" /> Formal Education</h2>
      <div className="timeline">
        {educationItems.map((item, index) => (
          <div key={index} className="timeline-item">
            <div className="timeline-year">{item.year}</div>
            <div className="timeline-content">
              <h3>{item.degree}</h3>
              <h4>{item.institution}</h4>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Education;
